webpackJsonp([190265308076868],{

/***/ 714:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(24);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _car = __webpack_require__(136);
	
	var _car2 = _interopRequireDefault(_car);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CorporateProgramEn = function CorporateProgramEn() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'page corporate_program' },
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Nicaragua Corporate Program with Budget Nicaragua',
	      meta: [{
	        name: 'description',
	        content: 'Frequently Asked Questions about car rentals.'
	      }],
	      link: [{
	        rel: 'alternate',
	        hreflang: 'en',
	        href: './es/corporate_program'
	      }]
	    }),
	    _react2.default.createElement('div', { className: 'image' }),
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Corporate Program'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'We have the vehicle that fits to your business needs'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Our corporate program offers affiliates exclusive benefits:'
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Special Rates'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Corporate Credit'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Personalized attention with an executive dedicated to your account'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Personalized attention'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Immediate credit approval'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Fixed rates throughout the year'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Drop of service at no additional cost (restrictions apply)'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Additional driver at no cost.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Airport charge exemption.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Monthly rental program (restrictions apply)'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Discounts for your employees.'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'The best option for your company!',
	          _react2.default.createElement('br', null),
	          'Contact us to obtain the best transport solution for your company,with the quality, service and trust that only Budget can offer you.'
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:negocios@budget.com.ni', className: 'btn' },
	            'Contact Us'
	          )
	        )
	      )
	    )
	  );
	};
	exports.default = CorporateProgramEn;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-corporate-program-en-js-84f622125bcbd8a858e4.js